import { BlogCard } from "./BlogCard";

interface BlogPost {
  id: string;
  title: string;
  description: string;
  date: string;
  image_url: string;
  category: string;
  slug: string;
}

interface BlogGridProps {
  posts: BlogPost[];
}

export const BlogGrid = ({ posts }: BlogGridProps) => {
  if (posts.length === 0) {
    return (
      <div className="col-span-full text-center text-gray-500">
        No blog posts available at the moment.
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post) => (
        <BlogCard key={post.id} post={post} />
      ))}
    </div>
  );
};